import React from 'react';
import styled from 'styled-components';
import WidthWrapper from './WidthWrapper';

const StyledTerms = styled.section`
  padding: 5rem 0 10.5rem;
  overflow-y: hidden;

  .width-wrapper {
    max-width: 40rem;
    display: flex;
    flex-direction: column;
  }

  h2 {
    font-size: 2.25rem;
    margin-bottom: 0.5rem;
  }

  h3 {
    margin-top: 2rem;
    margin-bottom: 1.5rem;
  }

  p {
    white-space: normal;
    word-break: break-word;
    width: 100%;
    margin-bottom: 1.25rem;
  }

  a {
    text-decoration: none;
    color: var(--primary);
  }

  @media only screen and (max-width: 640px) {
    padding: 5rem 1rem 10.5rem 1rem;

    .width-wrapper {
      width: 100%;
    }
  }
`;

const Terms = ({ children }) => {
  return (
    <StyledTerms>
      <WidthWrapper>{children}</WidthWrapper>
    </StyledTerms>
  );
};

export default Terms;
